import { checkIfUTCDateEqual } from '../date';

const checkIfLocakStorageDateIsToday = (key: string): boolean => {
  const lastTimeWhenContractVisit = localStorage.getItem(key);

  if (!lastTimeWhenContractVisit) {
    return false;
  }

  return checkIfUTCDateEqual(new Date(), new Date(lastTimeWhenContractVisit));
};

export { checkIfLocakStorageDateIsToday };
